module.exports = __webpack_public_path__ + "img/bg_7.0777a333.webp";